import type { NextPage } from 'next'
import styles from './EntryComponent.module.scss'
import { useRouter } from 'next/navigation'
import { Activity } from 'types/user'
import { Entry } from 'types/entry'
import EntryScrollableComponentContainer from '../entryScrollableComponentContainer'
import { useAppSelector } from 'reducers/storeHooks'
import { EntryDateIndex } from 'reducers/postReducer'
import { isDev } from 'app/general'
import { getEventUrl } from 'helpers/navigation'

interface Props {
  entry?: Entry
  // entryId: string
  // activity: Activity
  // showorganiser?: boolean
  hideOptions?: boolean
  entryDateIndex?: EntryDateIndex
  hideEventTitle?: boolean

}

const EventComponent: NextPage<Props> = (props: Props) => {
  const entries = useAppSelector((state) => state.eventReducer.events)
  const entry = props.entry ?? (props.entryDateIndex ? entries.get(props.entryDateIndex.entryId) : null)


  const router = useRouter()

  const goToEvent = () => {
    router.push(getEventUrl(entry?.id as string))
  }

  if (!entry) {
    if (process.env.NODE_ENV !== 'production')
      isDev && console.log("No Entry: " + props.entryDateIndex?.entryId)
    return (<></>)
  }

  return (
    <EntryScrollableComponentContainer
      type={props.hideEventTitle ? "" : entry.title}
      options={props.hideOptions ? undefined : []
      }>
      <div className={styles.imageWrapper} onClick={goToEvent}>
        <img src={entry.image} className={styles.image} />
      </div>
    </EntryScrollableComponentContainer>
  )
}

export default EventComponent
